// extracted by mini-css-extract-plugin
export var logo = "_9c-2";
export var logoWrapper = "_9c-1";
export var strip = "_9c-0";